import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { SupportAgent } from "types/SupportAgent";
import { handleRequestError } from "utils/Request";

async function fetchSupportAgents(categoryId: string): Promise<SupportAgent[]> {
  const { data } = await api.get('/support/agents', { params: { category_id: categoryId } });
  return data;
}

export function useSupportAgents(categoryId: string) {
  const query = useQuery(['support-agents', categoryId], () => fetchSupportAgents(categoryId), {
    enabled: !!categoryId,
  });

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Erro ao listar agentes do suporte. Tente novamente.');
  }, [query.isError, query.error]);

  return query;
}
